import React from "react";
import { useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import EmailPage from "../components/EmailManagement/EmailPage";
import TemplateList from "../components/EmailManagement/TemplateList";
import TemplateForm from "../components/EmailManagement/TemplateForm";

// Email role: notification template master, one template per event with SMS / WhatsApp / Email
// (?page=list | create | edit&id=)
export default function NotificationTemplates() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get("page") || "list";
  const listPath = `/${Cookies.get("mhet_mst_project")}/notification-templates?page=list`;
  const title = page === "create" ? "Add Template" : page === "edit" ? "Edit Template" : "Notification Templates";
  const crumbs = page === "list" ? [{ label: "Notification Templates" }] : [{ label: "Notification Templates", to: listPath }, { label: page === "create" ? "Add" : "Edit" }];
  return (
    <EmailPage title={title} crumbs={crumbs}>
      {page === "list" ? <TemplateList /> : <TemplateForm key={searchParams.get("id") || "new"} />}
    </EmailPage>
  );
}
